import React, { useMemo } from 'react';
import {
  Alert, Button, Card, Col, Container, Row, Spinner,
} from 'react-bootstrap';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { EXTERNAL_SALES_BASE_PATH } from '../../config';
import { readUtm } from '../../readUtm';
import { CheckoutForm } from './CheckoutForm';
import { useCheckout } from './useCheckout';

export function CheckoutPage() {
  const { campaignCode } = useParams<{ campaignCode: string }>();
  const history = useHistory();
  const { search } = useLocation();

  const sku = useMemo(() => new URLSearchParams(search).get('sku') ?? '', [search]);
  const utm = useMemo(() => readUtm(search), [search]);

  const { state, submit } = useCheckout({ campaignCode, sku, utm });

  const busy = state.kind === 'submitting' || state.kind === 'redirecting';

  return (
    <div className="external-sales-page">
      <Container as="main" className="external-sales-checkout min-vh-100 d-flex align-items-center py-5">
        <Row className="justify-content-center w-100">
          <Col xs={12} md={7} lg={5}>
            {!sku ? (
              <Alert variant="warning" className="mb-0">No offer selected.</Alert>
            ) : (
              <Card className="shadow-sm border-0">
                <Card.Body className="p-4">
                  <Card.Title className="h4 mb-4">Checkout</Card.Title>

                  {state.kind === 'rejected' && (
                    <Alert variant="warning">This offer isn’t available. Please go back and choose another.</Alert>
                  )}
                  {state.kind === 'error' && (
                    <Alert variant="danger">Something went wrong. Please try again.</Alert>
                  )}
                  {busy && (
                    <div className="d-flex align-items-center mb-3 text-muted" role="status">
                      <Spinner animation="border" size="sm" className="mr-2" aria-hidden="true" />
                      Redirecting to secure checkout…
                    </div>
                  )}

                  <CheckoutForm disabled={busy} onSubmit={submit} />
                </Card.Body>
              </Card>
            )}
            {!busy && (
              <Button
                variant="outline-secondary"
                block
                className="mt-4"
                onClick={() => history.push(`${EXTERNAL_SALES_BASE_PATH}/c/${encodeURIComponent(campaignCode)}`)}
              >
                Cancel
              </Button>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
